import Tooltip from '../../components/Tooltip/Tooltip'
import React from 'react'

class TooltipWithErrorBoundary extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.log('TooltipWithErrorBoundary caught an error:', error, errorInfo)
        const { children, selection, history } = this.props.editor ?? {}
        if (this.props.onError) {
            this.props.onError(error, { children, history, selection })
        }
        else {
            console.error(error, { children, history, selection })
        }
    }

    render() {
        const { children, content, position, ...rest } = this.props
        if (this.state.hasError) {
            return children
        }

        return (
            <Tooltip content={content} position={position} {...rest} ><>{children}</></Tooltip>
        )
    }
}

export default TooltipWithErrorBoundary